module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    staticClass: "regular-form",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.handleSubmit()
      }
    }
  }, [_c('client-first-name-field', {
    attrs: {
      "error": _vm.$attrs.errors.client.first_name
    },
    model: {
      value: (_vm.$attrs.client.first_name),
      callback: function($$v) {
        _vm.$set(_vm.$attrs.client, "first_name", $$v)
      },
      expression: "$attrs.client.first_name"
    }
  }), _vm._v(" "), _c('client-middle-name-field', {
    attrs: {
      "error": _vm.$attrs.errors.client.middle_name
    },
    model: {
      value: (_vm.$attrs.client.middle_name),
      callback: function($$v) {
        _vm.$set(_vm.$attrs.client, "middle_name", $$v)
      },
      expression: "$attrs.client.middle_name"
    }
  }), _vm._v(" "), _c('client-last-name-field', {
    attrs: {
      "error": _vm.$attrs.errors.client.last_name
    },
    model: {
      value: (_vm.$attrs.client.last_name),
      callback: function($$v) {
        _vm.$set(_vm.$attrs.client, "last_name", $$v)
      },
      expression: "$attrs.client.last_name"
    }
  }), _vm._v(" "), _c('phone-field', {
    attrs: {
      "error": _vm.$attrs.errors.client.phone
    },
    model: {
      value: (_vm.$attrs.client.phone),
      callback: function($$v) {
        _vm.$set(_vm.$attrs.client, "phone", $$v)
      },
      expression: "$attrs.client.phone"
    }
  }), _vm._v(" "), _c('contract-number-field', {
    attrs: {
      "error": _vm.$attrs.errors.client.contract_number
    },
    model: {
      value: (_vm.$attrs.client.contract_number),
      callback: function($$v) {
        _vm.$set(_vm.$attrs.client, "contract_number", $$v)
      },
      expression: "$attrs.client.contract_number"
    }
  }), _vm._v(" "), _c('apartment-field', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!(_vm.formType == 'add' && _vm.$attrs.client.apartment)),
      expression: "!(formType == 'add' && $attrs.client.apartment)"
    }],
    attrs: {
      "error": _vm.$attrs.errors.client.apartment
    },
    model: {
      value: (_vm.$attrs.client.apartment),
      callback: function($$v) {
        _vm.$set(_vm.$attrs.client, "apartment", $$v)
      },
      expression: "$attrs.client.apartment"
    }
  }), _vm._v(" "), _c('rate-plan-field', {
    attrs: {
      "error": _vm.$attrs.errors.client.rate_plan
    },
    model: {
      value: (_vm.$attrs.client.rate_plan),
      callback: function($$v) {
        _vm.$set(_vm.$attrs.client, "rate_plan", $$v)
      },
      expression: "$attrs.client.rate_plan"
    }
  }), _vm._v(" "), _c('discount-field', {
    attrs: {
      "error": _vm.$attrs.errors.client.discount
    },
    model: {
      value: (_vm.$attrs.client.discount),
      callback: function($$v) {
        _vm.$set(_vm.$attrs.client, "discount", $$v)
      },
      expression: "$attrs.client.discount"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group text-center"
  }, [_c('input', {
    staticClass: "btn btn-primary btn-lg",
    attrs: {
      "type": "submit"
    },
    domProps: {
      "value": _vm.submitLabel
    }
  })])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c7ca726a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/forms/client/ClientBlankForm.vue
// module id = 710
// module chunks = 0